import { AddToCartStyleTokens } from "./addToCart.tokens";

export const AddToCartStyles: AddToCartStyleTokens = {
    goToCartButton: {
        color: "secondary"
    }
};
